import React, { Component } from "react";
import { Card, Col, Container, Form, Row, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default class ZunoKycpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chpiId: sessionStorage.getItem("chpiId"),
      proposalId: sessionStorage.getItem("proposalId"),
      proposalNum: sessionStorage.getItem("proposalNum"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      cqrId: sessionStorage.getItem("cqrId"),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      zuno_totalAmount: sessionStorage.getItem("totalAmount"),
      policyuuid: sessionStorage.getItem("policyId"),
      policieskyc: [],
      idTYPE: "",
      idNum: "",
      dob: null,
      aadharno: "",
      gender: "",
      name: "",
      ovdType: "",
      filePath: "",
      mobileNum: "",
      email: "",
      pan: "",
      docType: "",
      extension: "pdf",
      frontSide: "",
      proposerType: "I",
      jsonDisplay: null,
      errorMessage: "",
      showAadharForm: false,
      showUploadform: false,
      noPanCard: false,
      startDate: new Date(),
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    const uppercaseValue = value.toUpperCase();

    this.setState({
      [name]: name === "idNum" ? uppercaseValue : value,
      errors: {
        ...this.state.errors,
        [name]: uppercaseValue,
      },
    });
  };
  handleaProofChange = (e) => {
    const file = e.target.files[0];
    // const newFormData = this.state.aProof;
    // newFormData["aProof"] = file;
    this.setState({ aProof: file });
  };
  handleDChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      console.log(date);
      console.log(formattedDate);
      // Assuming you want to update the 'dob' state with the selected date
      this.setState({
        dob: formattedDate,
        startDate: new Date(),
      });
    }
  };

  validateForm() {
    let policykyc = this.state;
    let errors = {};
    let formIsValid = true;
    if (!policykyc["idTYPE"]) {
      formIsValid = false;
      toast.info("*Please Enter Document Type.");
    } else if (!policykyc["idNum"]) {
      formIsValid = false;
      toast.info("*Please Enter PAN Number.");
    } else if (
      policykyc["idTYPE"] === "PAN" &&
      !/^[A-Z]{3}P[A-Z]{1}[0-9]{4}[A-Z]{1}$/.test(policykyc["idNum"])
    ) {
      // Check PAN validation only when idTYPE is "PAN"
      formIsValid = false;
      toast.info("*Invalid PAN Number format.");
    } else if (policykyc["idNum"].length !== 10) {
      // Check if PAN Number has exactly 10 characters
      formIsValid = false;
      toast.info("*PAN Number should be 10 characters long.");
    } else if (!policykyc["dob"]) {
      formIsValid = false;
      toast.info("*Please Enter Date of Birth.");
    }

    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleSubmitClick = (e) => {
    const formatDateToMMDDYYYY = (dateString) => {
      const date = new Date(dateString);
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months start from 0
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };
    const generateLeadId = () => {
      const timestamp = Date.now(); // Gets current timestamp in milliseconds
      const randomNum = Math.floor(Math.random() * 1000); // A random number between 0 and 999
      return `HHS${timestamp}${randomNum}`;
    };
    const leadId = generateLeadId();
    sessionStorage.setItem("currentLeadId", leadId);
    const redirectUrls = "https://dev-app.apnapolicy.co.in/zunothankspage/";
    const jsonData = {
      source: "ApnaPolicyHealth",
      leadId: leadId,
      kycId: {
        idType: this.state.idTYPE,
        idNumber: this.state.idNum,
      },
      proposer: {
        dobDoi: formatDateToMMDDYYYY(this.state.dob),
        email: this.state.email,
        gender: this.state.gender,
        mobileNum: this.state.mobileNum,
        name: this.state.name,
        proposerType: "I",
      },
      additional: {
        redirectUrl: redirectUrls,
      },
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 354);
    formData.append("savedata", "yes");
    //formData.append("jsonData", JSON.stringify(jsonData1));
    formData.append("jsonData", jsonData1);
    sessionStorage.setItem("kycjsondata", jsonData1);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true });
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponsejsonfetchHandler();
          }, 10000);
        }
      });
  };
  ResponsejsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 354);
    formData.append("requestId", sessionRequestId);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Store the quotes data
          this.setState({
            quotesss: data.data,
          });

          // Handle premium calculation (your existing logic)
          const selectedPlanName = sessionStorage.getItem("selectedPlanName");
          const plans = data.data.policyData?.applicablePlans || {};
          const premiumDetails = plans[selectedPlanName]?.premiumDetails || {};
          const totalPremium = premiumDetails.totalPremium ?? 0;
          this.setState({
            quotesss: data.data,
            updatepremium: totalPremium,
            //kycShortUrl: kycShortUrl || "",
          });

          // NEW: Handle KYC URL redirect
          // const kycShortUrl = data.data?.data?.meta?.kycShortUrl;
          // if (kycShortUrl) {
          //   this.KycfetchHandler(kycShortUrl); // ✅ Call next API with the URL
          // }
        }
        const kycShortUrl = data.data?.data?.meta?.kycShortUrl;

        if (kycShortUrl) {
          // Option 1: Redirect in the same window
          window.location.href =
            configData.api_url +
            "C_Integrationlibrary/redirect?redirectUrl=" +
            kycShortUrl;
        } else {
          console.warn("KYC URL not found in response");
          this.showToast("KYC URL not available", "warning");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch response JSON:", err);
        this.showToast("Unable to load premium details", "error");
      });
  };
  //Aadhar
  handleaadharSubmitClick = (e) => {
    const formatDateToMMDDYYYY = (dateString) => {
      const date = new Date(dateString);
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months start from 0
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };
    const generateLeadId = () => {
      const timestamp = Date.now(); // Gets current timestamp in milliseconds
      const randomNum = Math.floor(Math.random() * 1000); // A random number between 0 and 999
      return `HHS${timestamp}${randomNum}`;
    };
    const jsonData = {
      source: "ApnaPolicyHealth",
      leadId: generateLeadId(),
      kycId: {
        idType: this.state.idTYPE,
        idNumber: this.state.idNum,
      },
      proposer: {
        dobDoi: formatDateToMMDDYYYY(this.state.dob),
        email: this.state.email,
        gender: this.state.gender,
        mobileNum: this.state.mobileNum,
        name: this.state.name,
        proposerType: "I",
      },
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 356);
    formData.append("savedata", "yes");
    //formData.append("jsonData", JSON.stringify(jsonData1));
    formData.append("jsonData", jsonData1);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true });
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponseaadharjsonfetchHandler();
          }, 10000);
        }
      });
  };
  ResponseaadharjsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 356);
    formData.append("requestId", sessionRequestId);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Store the quotes data
          this.setState({
            quotesss: data.data,
          });
          // Handle premium calculation (your existing logic)
          const selectedPlanName = sessionStorage.getItem("selectedPlanName");
          const plans = data.data.policyData?.applicablePlans || {};
          const premiumDetails = plans[selectedPlanName]?.premiumDetails || {};
          const totalPremium = premiumDetails.totalPremium ?? 0;
          this.setState({
            quotesss: data.data,
            updatepremium: totalPremium,
            //kycShortUrl: kycShortUrl || "",
          });

          // NEW: Handle KYC URL redirect
          // const kycShortUrl = data.data?.data?.meta?.kycShortUrl;
          // if (kycShortUrl) {
          //   this.KycfetchHandler(kycShortUrl); // ✅ Call next API with the URL
          // }
        }
        const kycShortUrl = data.data?.data?.meta?.kycShortUrl;

        if (kycShortUrl) {
          // Option 1: Redirect in the same window
          window.location.href =
            configData.api_url +
            "C_Integrationlibrary/redirect?redirectUrl=" +
            kycShortUrl;
        } else {
          console.warn("KYC URL not found in response");
          this.showToast("KYC URL not available", "warning");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch response JSON:", err);
        this.showToast("Unable to load premium details", "error");
      });
  };
  //File Upload
  handlefileSubmitClick = (e) => {
    const generateLeadId = () => {
      const timestamp = Date.now(); // Gets current timestamp in milliseconds
      const randomNum = Math.floor(Math.random() * 1000); // A random number between 0 and 999
      return `HHS${timestamp}${randomNum}`;
    };
    const jsonData = {
      source: "ApnaPolicyHealth",
      leadId: generateLeadId(),
      proposer: {
        name: this.state.name,
        pan: this.state.pan,
      },
      uploads: {
        kycDocument: {
          docType: this.state.idTYPE,
          extension: "pdf",
          frontSide: "",
          backSide: "",
        },
      },
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 355);
    formData.append("savedata", "yes");
    //formData.append("jsonData", JSON.stringify(jsonData1));
    formData.append("jsonData", jsonData1);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true });
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponsefilejsonfetchHandler();
          }, 10000);
        }
      });
  };
  ResponsefilejsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 355);
    formData.append("requestId", sessionRequestId);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Store the quotes data
          this.setState({
            quotesss: data.data,
          });

          // Handle premium calculation (your existing logic)
          const selectedPlanName = sessionStorage.getItem("selectedPlanName");
          const plans = data.data.policyData?.applicablePlans || {};
          const premiumDetails = plans[selectedPlanName]?.premiumDetails || {};
          const totalPremium = premiumDetails.totalPremium ?? 0;
          this.setState({
            quotesss: data.data,
            updatepremium: totalPremium,
            //kycShortUrl: kycShortUrl || "",
          });

          // NEW: Handle KYC URL redirect
          // const kycShortUrl = data.data?.data?.meta?.kycShortUrl;
          // if (kycShortUrl) {
          //   this.KycfetchHandler(kycShortUrl); // ✅ Call next API with the URL
          // }
        }
        const kycShortUrl = data.data?.data?.meta?.kycShortUrl;

        if (kycShortUrl) {
          // Option 1: Redirect in the same window
          window.location.href =
            configData.api_url +
            "C_Integrationlibrary/redirect?redirectUrl=" +
            kycShortUrl;
        } else {
          console.warn("KYC URL not found in response");
          this.showToast("KYC URL not available", "warning");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch response JSON:", err);
        this.showToast("Unable to load premium details", "error");
      });
  };
  onKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleNoPANClick = () => {
    // Function to handle click on "I don't have PAN card"
    this.setState({
      noPanCard: true,
      idTYPE: "aadhaar", // Set default ID type to Aadhar
      showAadharForm: true,
    });
  };
  handleNoUPLOAdClick = () => {
    this.setState({
      noPanCard: true,
      idTYPE: "pan",
      showUploadform: true,
    });
  };
  handleaddrssChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ docType: fieldValue });
  };
  handlenameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ name: fieldValue });
  };
  handleaddressuploadChange = (e) => {
    e.preventDefault();
    const files = e.target.files[0];
    this.setState({ frontSide: files });
  };
  handlebacksideuploadChange = (e) => {
    e.preventDefault();
    const files = e.target.files[0];
    this.setState({ backSide: files });
  };
  handleButtonClick = () => {
    const amount = sessionStorage.getItem("totalAmount");
    const policyId = sessionStorage.getItem("policyId");
    window.location.href =
      configData.api_url +
      `payments/zunopayments?amount=${amount}&policyId=${policyId}`;
    // window.location.href =
    //   configData.api_url +
    //   "payments/zunopayments?amount=1000&policyId=6128058a-3ff6-4e38-b712-9ed1b8d1d52e";
  };
  render() {
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0);
    previousYearStart.setDate(1);
    const endYear = new Date();
    endYear.setFullYear(endYear.getFullYear() + 10);
    return (
      <div>
        <h3 className="logoskybluecolor">Zuno Kyc page</h3>
        <Container>
          <Card>
            <Card.Body>
              <div className="row">
                <div className="col-md-4">
                  <label for="exampleFormControlInput1" className="form-label">
                    Pan Card:
                  </label>
                  <Form.Select
                    name="idTYPE"
                    value={this.state.idTYPE}
                    onChange={this.handleChange}
                    aria-label="Default select example"
                    className="form-control"
                    id="idTYPE"
                    disabled={this.state.showAadharForm}
                  >
                    <option selected>select Identity Type</option>
                    <option value="pan">PAN</option>
                  </Form.Select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="dob" className="form-label">
                    NAME:
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={this.state.name}
                    className="form-control"
                    id="name"
                    placeholder="Enter Name"
                    onChange={this.handleChange}
                    disabled={this.state.showAadharForm}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="idNum" className="form-label">
                    PAN No:
                  </label>
                  <input
                    type="text"
                    name="idNum"
                    value={this.state.idNum}
                    className="form-control"
                    id="idNum"
                    placeholder="Enter PAN Number"
                    onChange={this.handleChange}
                    disabled={this.state.showAadharForm}
                  />
                  <Link id="noPANBtn" onClick={this.handleNoPANClick}>
                    I don't have PAN card
                  </Link>
                </div>
                <div className="col-md-4">
                  <label htmlFor="dob" className="form-label">
                    DOB:
                  </label>

                  <div calendarClassName="custom-calendar">
                    <DatePicker
                      dropdownMode="select"
                      dateFormat="dd/MM/yyyy"
                      showTimeSelect={false}
                      selected={this.state.dob}
                      onChange={(date) => this.handleDChange(date)}
                      className="form-control"
                      id="dob"
                      placeholderText="Select Date of Birth"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      minDate={previousYearStart} // Set the minimum selectable date
                      maxDate={endYear} // Set the maximum selectable date
                      disabled={this.state.showAadharForm}
                    />
                  </div>
                </div>
              </div>
              <br />
              <Row className="justify-content-between">
                <Col lg="12" md="12">
                  <Button
                    id="getQuotes4"
                    type="submit"
                    onClick={this.handleSubmitClick}
                    style={{ float: "right" }}
                    disabled={this.state.showAadharForm}
                  >
                    Submit{" "}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <br />
          {this.state.showAadharForm && (
            <Card>
              <Card.Body>
                <div className="text-center">Aadhar Verification</div>
                <div className="row">
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Aadhaar Card:
                    </label>
                    <Form.Select
                      name="idTYPE"
                      value={this.state.idTYPE}
                      aria-label="Default select example"
                      className="form-control"
                      id="idTYPE"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    >
                      <option selected>select Identity Type</option>
                      <option value="aadhaar">AADHAR</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      Aadhar Card No:
                    </label>
                    <input
                      onKeyDown={this.onKeyDown}
                      type="text"
                      name="idNum"
                      value={this.state.idNum}
                      className="form-control"
                      id="idNum"
                      placeholder="Enter Aadhar Number"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    />
                    <Link id="noPANBtn" onClick={this.handleNoUPLOAdClick}>
                      I don't have AADHAR card
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      NAME:
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={this.state.name}
                      className="form-control"
                      id="name"
                      placeholder="Enter Name"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      Gender:
                    </label>
                    <Form.Select
                      name="gender"
                      value={this.state.gender}
                      onChange={this.handleChange}
                      aria-label="Default select example"
                      className="form-control"
                      id="gender"
                      disabled={this.state.showUploadform}
                    >
                      <option selected>select</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="O">Other</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      DOB:
                    </label>
                    <div calendarClassName="custom-calendar">
                      <DatePicker
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        showTimeSelect={false}
                        selected={this.state.dob}
                        onChange={(date) => this.handleDChange(date)}
                        className="form-control policiesdatepicker"
                        id="dob"
                        placeholderText="Select Date of Birth"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        minDate={previousYearStart} // Set the minimum selectable date
                        maxDate={endYear}
                        popperClassName="date-picker-reports"
                        disabled={this.state.showUploadform}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      Mobile No:
                    </label>
                    <input
                      type="number"
                      name="mobileNum"
                      value={this.state.mobileNum}
                      className="form-control"
                      id="mobileNum"
                      placeholder="Enter Number"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dob" className="form-label">
                      E Mail:
                    </label>
                    <input
                      type="text"
                      name="email"
                      value={this.state.email}
                      className="form-control"
                      id="email"
                      placeholder="Enter E Mail"
                      onChange={this.handleChange}
                      disabled={this.state.showUploadform}
                    />
                  </div>
                </div>
                <br />
                <Row className="justify-content-between">
                  <Col lg="12" md="12">
                    <Button
                      id="getQuotes4"
                      type="submit"
                      onClick={this.handleaadharSubmitClick}
                      style={{ float: "right" }}
                      disabled={this.state.showUploadform}
                    >
                      Submit{" "}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
          <br />
          {this.state.showUploadform && (
            <Card>
              <Card.Body>
                <div className="text-center">Document Verification</div>
                <div className="row">
                  <div className="col-md-4">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      Address Proof:
                    </label>
                    <Form.Select
                      name="docType"
                      value={this.state.docType}
                      aria-label="Default select example"
                      className="form-control"
                      id="docType"
                      onChange={this.handleChange}
                    >
                      <option selected>select Address Type</option>
                      <option value="pan">PAN</option>
                      <option value="aadhaar">Aadhaar</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      Name:
                    </label>
                    <input
                      onChange={this.handleChange}
                      type="text"
                      name="name"
                      value={this.state.name}
                      className="form-control"
                      id="name"
                      placeholder="Enter Name"
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      PAN No:
                    </label>
                    <input
                      type="text"
                      name="pan"
                      value={this.state.pan}
                      className="form-control"
                      id="pan"
                      placeholder="Enter PAN Number"
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      Front Side:
                    </label>
                    <input
                      // onKeyDown={this.onKeyDown}
                      type="file"
                      name="frontSide"
                      //value={this.state.frontSide}
                      className="form-control"
                      id="frontSide"
                      placeholder=""
                      onChange={this.handleaddressuploadChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="idNum" className="form-label">
                      Back Side:
                    </label>
                    <input
                      // onKeyDown={this.onKeyDown}
                      type="file"
                      name="backSide"
                      //value={this.state.frontSide}
                      className="form-control"
                      id="backSide"
                      placeholder=""
                      onChange={this.handlebacksideuploadChange}
                    />
                  </div>
                </div>
                <br />
                <Row className="justify-content-between">
                  <Col lg="12" md="12">
                    <Button
                      id="getQuotes4"
                      type="submit"
                      onClick={this.handlefileSubmitClick}
                      style={{ float: "right" }}
                      // disabled={this.state.showUploadform}
                    >
                      Submit{" "}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </Container>
      </div>
    );
  }
}
